import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectSaved, selectSaving, selectError, selectLesson } from '../selectors/lesson.selector';
import { lessonActions } from '../actions/lesson.actions';
import { LessonValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class LessonFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly saving$ = this.store.select(selectSaving);
    readonly saved$ = this.store.select(selectSaved);
    readonly lesson$ = this.store.select(selectLesson);
    readonly lessonNonNullable$ = this.store.select(selectLesson).pipe(filter((lesson) => lesson !== null));

    readonly lesson = this.store.selectSignal(selectLesson);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = this.store.selectSignal(selectError);

    getLesson(id: string): void {
        this.store.dispatch(lessonActions.getLesson({ id }));
    }

    createLesson(value: LessonValue): void {
        this.store.dispatch(lessonActions.createLesson({ value }));
    }

    updateLesson(id: string, value: LessonValue): void {
        this.store.dispatch(lessonActions.updateLesson({ id, value }));
    }

    deleteLesson(id: string): void {
        this.store.dispatch(lessonActions.deleteLesson({ id }));
    }

    clear(): void {
        this.store.dispatch(lessonActions.clear());
    }
}
